export const NameSpace = {
  APP: 'APP',
}
